import styles from '../styles/Experience.module.css';

const TIMELINE = [
  {
    period: '2022 — 2023',
    company: 'Fronx Solutions',
    role: 'WordPress Developer',
    desc: 'Built fully custom WordPress themes from scratch using Bootstrap, JavaScript, and PHP. Contributed to debugging, performance optimization, and plugin configuration — delivering pixel-perfect UI/UX alongside senior developers.',
  },
  {
    period: '2023 — 2024',
    company: 'KGT Global',
    role: 'WordPress Developer',
    desc: 'Developed and maintained responsive WordPress websites using Elementor and Divi Builder. Collaborated with SEO specialists and designers, diagnosing and resolving technical issues to improve page load performance.',
  },
  {
    period: '2024 — Present',
    company: 'Mevteck',
    companySub: '— Karachi',
    role: 'Full Stack Developer',
    desc: 'Leading full-cycle development across server infrastructure, SaaS architecture, and client web platforms.',
    bullets: [
      'Architected a multi-tenant AI Chatbot SaaS platform (MERN) with PayPal billing and real-time live-agent handoff via Socket.io',
      'Delivered 100+ custom WordPress websites — themes, plugins, WooCommerce and ACF-based builds',
      'Rebuilt & manage VPS infrastructure hosting 30+ client sites, including DNS, security, and automation',
      'Configured SPF, DKIM, DMARC and SMTP across multiple domains to improve email deliverability',
    ],
    current: true,
  },
];

export default function Experience() {
  return (
    <section id="experience" className="section">
      <div className="container">
        <div className="section-head" data-anim>
          <span className="section-index">04</span>
          <span className="section-rule" />
          <h2 className="section-title">Experience</h2>
        </div>

        <div className={styles.timeline} data-timeline>
          <div className={styles.track} />
          <div className={styles.progress} data-timeline-line />

          {TIMELINE.map((entry) => (
            <div key={entry.company} className={styles.item} data-anim>
              <span className={`${styles.dot} ${entry.current ? styles.current : ''}`} />
              <div className={`${styles.period} ${entry.current ? styles.current : ''}`}>{entry.period}</div>
              <h3 className={styles.company}>
                {entry.company} {entry.companySub && <span className={styles.companySub}>{entry.companySub}</span>}
              </h3>
              <div className={styles.role}>{entry.role}</div>
              <p className={styles.desc}>{entry.desc}</p>
              {entry.bullets && (
                <ul className={styles.bullets}>
                  {entry.bullets.map((bullet) => (
                    <li key={bullet} className={styles.bulletItem}>
                      {bullet}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
